import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView, meta: { title: '首页' } },
  { path: '/properties', name: 'properties', component: () => import('@/views/PropertiesView.vue'), meta: { title: '房源中心' } },
  { path: '/services', name: 'services', component: () => import('@/views/ServicesView.vue'), meta: { title: '服务与咨询' } },
  { path: '/about', name: 'about', component: () => import('@/views/AboutView.vue'), meta: { title: '关于我们' } },
  { path: '/register', name: 'register', component: () => import('@/views/RegisterView.vue'), meta: { title: '用户注册' } },
  { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { title: '会员登录' } },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

const BASE = '浙江嘉兴市三剑客房产经纪有限责任公司'
router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · ${BASE}` : BASE
})

export default router
